import debounce from 'transmute/debounce';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import UISearchInput from 'UIComponents/input/UISearchInput';
import Filters from '../../models/Filters';
import { clearSearchTerms, enterSearchTerms } from '../../actions/SearchTermsActions';
import { clearTickets, searchTickets } from '../../actions/TicketActions';
import { jsx as _jsx } from "react/jsx-runtime";
const SEARCH_DELAY_MILLIS = 500;
function handleTicketSearch(searchTerms, filters, dispatch) {
  dispatch(searchTickets(searchTerms, filters, 'search-terms-entered'));
}
const searchTicketsDelayed = debounce(SEARCH_DELAY_MILLIS, (value, filters, dispatch) => handleTicketSearch(value, filters, dispatch));
function TicketSearchInput() {
  const dispatch = useDispatch();
  const filters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  const searchTerms = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.searchTerms);
  const tickets = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.tickets);
  function handleInputChanged(value) {
    if (!value.trim()) {
      dispatch(clearSearchTerms());
      dispatch(clearTickets());
      if (!filters.equals(new Filters())) {
        dispatch(searchTickets(value, filters, 'search-terms-cleared'));
      }
    } else {
      dispatch(enterSearchTerms(value));
      searchTicketsDelayed(value, filters, dispatch);
    }
  }
  return /*#__PURE__*/_jsx(UISearchInput, {
    "data-test-id": "ticket-search-input-internal",
    disabled: tickets.isLoading,
    placeholder: I18n.text('app.common.searchHubSpotTickets'),
    value: searchTerms
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
    ,
    onChange: ({
      target: {
        value
      }
    }) => handleInputChanged(value)
  });
}
export default TicketSearchInput;